export { default } from './CDCProtegido25Banner';
